import RootState from '../../typings/RootState'
import { Event } from '../types/event'

export const selectUploadList = (state: RootState): any[] =>
  state.uploadFile.UploadList

export const selectUploadEvent = (state: RootState): Event =>
  state.uploadFile.Event
